import { zSchema, schemes } from "@zeal/common";

export const createOrderRequestSchema = zSchema
  .object({
    companyID: schemes.uuid(),
    customerAccountID: schemes.uuid(),
    approval_required: zSchema.boolean(),
    contractor_payments: zSchema.array(schemes.mongoObjectId()).optional(),
    flat: zSchema.number().optional(),
    memo: zSchema.string().optional(),
  })
  .refine(
    (data) =>
      (data.contractor_payments?.length ?? 0) > 0 || (data.flat ?? 0) > 0,
    {
      message: "Either `contractor_payments` or `flat` must be provided",
    }
  );

export type TCreateOrderRequestSchema = zSchema.infer<
  typeof createOrderRequestSchema
>;

export const createOrderResponseSchema = zSchema.object({
  companyID: schemes.uuid(),
  customerAccountID: schemes.uuid(),
  orderID: schemes.uuid(),
  businessCardID: zSchema.string().optional(),
  approval_required: zSchema.boolean(),
  approved: zSchema.boolean(),
  contractor_payments: zSchema.array(schemes.mongoObjectId()).optional(),
  flat: zSchema.number(),
  last_four: zSchema.string().optional(),
  memo: zSchema.string().optional(),
  order_total: zSchema.number(),
  payment_receipt_link: zSchema.string().nullable(),
  status: zSchema.string(),
  submitted_at: zSchema.date().optional(),
});

export type TCreateOrderResponseSchema = zSchema.infer<
  typeof createOrderResponseSchema
>;
